import BenchlingConfig from 'BenchlingConfig';
import {BatchSchema} from 'constants/SampleConstants';
import InventoryStructuredTableMode from 'notebook/integrations/samples/InventoryStructuredTableMode';
import {TransferStructuredTableDestinationType} from 'notebook/integrations/samples/TransferStructuredTableAdapter';
import {getColumnLabel, renderColumnLabel} from 'notebook/structured-tables/columns/ColumnDefinitions';
import toColumnDefinition from 'notebook/structured-tables/columns/toColumnDefinition';
import {
  StructuredTableColumn,
  StructuredTableKind,
} from 'notebook/structured-tables/StructuredTableConstants';
import {ColumnConstraint, USER_CREATED_COLUMN_TYPES} from 'notebook/tables/constants/TableColumnConstants';
import {ParentStorableType} from 'samples/storables/StorableSchemaConstants';
import {Schema} from 'schemas/SchemaConstants';
import {StageRun} from 'workflows/WorkflowConstants';

export default function toColumnConstraint({
  structuredTableColumn,
  stageRuns,
  schemas,
  parentStorableIsGrid,
  parentStorableType,
  canChangeUnits,
  searchAllSchemas,
  mode: inventoryStructuredTableMode,
  kind: structuredTableKind,
  fallbackRegistryId,
  destinationType,
}: {
  structuredTableColumn: StructuredTableColumn;
  stageRuns?: Array<StageRun>;
  schemas: Array<Schema | BatchSchema>;
  parentStorableIsGrid?: boolean;
  parentStorableType?: ParentStorableType;
  canChangeUnits?: boolean;
  searchAllSchemas?: boolean;
  mode?: InventoryStructuredTableMode;
  kind?: StructuredTableKind;
  fallbackRegistryId?: string | null;
  destinationType?: TransferStructuredTableDestinationType;
}): ColumnConstraint {
  const columnDefinition = toColumnDefinition({
    structuredTableColumn,
    stageRuns,
    schemas,
    parentStorableIsGrid,
    parentStorableType,
    canChangeUnits,
    searchAllSchemas,
    inventoryStructuredTableMode,
    structuredTableKind,
    fallbackRegistryId,
    destinationType,
  });
  return {
    // Set such that only user created structured table columns can be renamed.
    editLabelDisabled: !USER_CREATED_COLUMN_TYPES.includes(structuredTableColumn.columnType),
    structuredTableColumn,
    columnDefinition,
    renderedLabel: BenchlingConfig.ELN_ENABLE_COLUMN_TYPE_ICONS
      ? getColumnLabel(columnDefinition)
      : renderColumnLabel(columnDefinition),
    isProtected: structuredTableColumn.isProtected,
  };
}
